// extracted by mini-css-extract-plugin
export default {"heading":"kw-z","corrected":"lw-z","redirectVerbiageContainer":"mw-z","redirectVerbiageText":"nw-z"};